import PropTypes from 'prop-types'
import React from 'react'
import styles from '../header.module.scss'
import { formatInternalURL, formatURL } from '../../../sm-constants/allNavBars'
import { ONE_TURF_BASE_URL } from '../../../sm-constants'
export default function CommonHeaderMobile({ data, firstParam, allSports, Container, CustomLink, pageRouterComp }) {
  const CustomContainer = Container || 'div'
  const baseUrl = ONE_TURF_BASE_URL
  const isActive = (slug) => {
    return slug.length > 1 ? firstParam === formatURL(slug) : firstParam === '/' ||
      firstParam.startsWith('/cricket') ||
      firstParam === '/icc-rankings' ||
      firstParam.includes('cricket')
  }
  return (
    <>
      <div className={`${styles.mobileSportsHeader}`}>
        <CustomContainer>
          <div className="d-flex align-items-center w-full position-relative">
            {[...data, ...allSports]?.map((d, i) => {
              return (
                <div
                  key={i}
                  className={`${isActive(d?.sSlug) ? styles.active : ''
                   } ${styles.mobileLink}`}>
                  <div>
                  {pageRouterComp ? (
                    d?.isNotInternal ? <a href={`${baseUrl.slice(0, -1)}${formatURL(d?.sSlug)}`} className={`${styles.menuItem} ${d?.sSlug === firstParam && 'font-bold'}`}>
                      {d?.sTitle}
                    </a> : <CustomLink href={formatInternalURL(d?.sSlug)}>
                      <a className={`${styles.menuItem} ${d?.sSlug === firstParam && styles.selectedLink}`}>{d?.sTitle}</a>
                    </CustomLink>
                  ) : (
                    <a href={`${baseUrl.slice(0, -1)}${formatURL(d?.sSlug)}`} className={`${styles.menuItem} ${d?.sSlug === firstParam && 'font-bold'}`}>
                      {d?.sTitle}
                    </a>
                  )}
                  </div>
                  <div
                    className={`${isActive(d?.sSlug) ? styles.selectedTriangle : ''
                      } ${styles.absolute}`}>
                         <div className={styles.triangleSlide}>
                         </div>
                      </div>
                </div>
              )
            })}
          </div>
        </CustomContainer >
      </div >
    </>
  )
}
CommonHeaderMobile.propTypes = {
  data: PropTypes.array,
  allSports: PropTypes.array,
  Container: PropTypes.any,
  CustomLink: PropTypes.any,
  firstParam: PropTypes.string,
  pageRouterComp: PropTypes.bool
}
